import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { TokenService } from "../../auth/token.service";
import jwt_decode from 'jwt-decode';
import { UserInfo } from "../model/user";

@Injectable({
    providedIn: 'root'
})
export class UserService{

    public usuarioSubject = new BehaviorSubject<UserInfo>({});

    constructor(private tokenService: TokenService){
        if (this.tokenService.hasToken()) {
            this.decodeJwt()
        }
    }

    public isAuthenticated(): boolean {
        return this.tokenService.hasToken();
    }

    public isTokenExpired(): boolean {
        let userinfo = this.usuarioSubject.getValue()
        if (!userinfo || typeof userinfo.exp !== 'number') {
            return true;
          }
        
        const expirationDate = new Date(userinfo?.exp * 1000)
        const actualDate = new Date()
        return expirationDate <= actualDate
    }

    decodeJwt(){
        const token = this.tokenService.retornaToken();
        const usuario = jwt_decode(token) as UserInfo
        this.usuarioSubject.next(usuario);
    }

    getUser(): Observable<UserInfo> {
        return this.usuarioSubject.asObservable();
    }

    logout() {
        this.tokenService.removeToken()
        this.usuarioSubject.next({})
    }

    salvarToken(token: string) {
        this.tokenService.salvaToken(token);
        this.decodeJwt()
    }   

    getRoles(): string {
        return this.usuarioSubject.getValue().roles ?? '';
    }

    getPrivileges(): string[] {
        return this.usuarioSubject.getValue().privileges ?? [];
    }
}